export default function isValidGuid(input) {
  const patternWithDashes = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
  const patternWithoutDashes = /^[0-9a-f]{8}[0-9a-f]{4}[1-5][0-9a-f]{3}[89ab][0-9a-f]{3}[0-9a-f]{12}$/i
  return patternWithDashes.test(input) || patternWithoutDashes.test(input)
}
